import lodash from 'lodash'
import React, { useEffect } from 'react'
import styled from 'styled-components'

import { toast } from '../../../../1stlog-ui/src/utils'
import useTemplates from '../useTemplates'
import Template from './Template'

const Wrapper = styled.div`
  flex: 1 1 0;
`

const TemplateList = (props) => {
  const {} = props

  const { templates, load } = useTemplates()

  const init = async () => {
    try {
      await load()
    } catch (err) {
      console.error('Failed to load templates', err)
      toast.error(
        i18n.t(
          'loading_order_templates_failed',
          'Laden der Auftragsvorlagen fehlgeschlagen',
        ),
      )
    }
  }

  useEffect(() => {
    if (templates) {
      return
    }
    init(templates)
  }, [templates])

  return (
    <Wrapper>
      <table className="table table-striped table-sm sm">
        <thead>
          <tr>
            <th>{i18n.t('name', 'Name')}</th>
            {/* <th>Abholung</th>
            <th>Zustellung</th> */}
            <th>{i18n.t('SLA', 'SLA')}</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {lodash.map(templates, (template) => (
            <Template template={template} />
          ))}
        </tbody>
      </table>
    </Wrapper>
  )
}

export default TemplateList
